var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBullhorn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.74997 7.5V19.0969C9.75111 19.2215 9.72078 19.3444 9.66179 19.4542C9.60279 19.564 9.51704 19.6572 9.41247 19.725L8.38122 20.4094C8.28131 20.4761 8.16685 20.5178 8.04746 20.531C7.92807 20.5443 7.80724 20.5287 7.69515 20.4855C7.58306 20.4423 7.48297 20.3728 7.40333 20.2829C7.32368 20.193 7.2668 20.0852 7.23747 19.9688L5.99997 15",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15C5.00544 15 4.05161 14.6049 3.34835 13.9017C2.64509 13.1984 2.25 12.2446 2.25 11.25C2.25 10.2554 2.64509 9.30161 3.34835 8.59835C4.05161 7.89509 5.00544 7.5 6 7.5H9.75C9.75 7.5 14.8594 7.5 19.7719 3.38438C19.8811 3.29396 20.0138 3.23638 20.1545 3.21831C20.2951 3.20024 20.4381 3.22243 20.5666 3.28229C20.6952 3.34216 20.8041 3.43726 20.8809 3.55655C20.9576 3.67584 20.9989 3.81443 21 3.95625V18.5438C20.9989 18.6856 20.9576 18.8242 20.8809 18.9435C20.8041 19.0627 20.6952 19.1578 20.5666 19.2177C20.4381 19.2776 20.2951 19.2998 20.1545 19.2817C20.0138 19.2636 19.8811 19.206 19.7719 19.1156C14.8594 15 9.75 15 9.75 15H6Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullhorn);
export default __webpack_public_path__ + "static/media/bullhorn.0eb4b9fffc968709a7101a2b3ea5c5ab.svg";
export { ForwardRef as ReactComponent };